import { createMachine } from 'xstate'

export const upgradePlanMachine = ({ initial = 'selectPlan' }: { initial: string }) =>
  createMachine({
    id: 'upgradePlan',
    initial,
    states: {
      selectPlan: {
        on: {
          CONTINUE_TO_PAYMENT: 'payment',
          PROVIDE_REASON: 'provideReason',
        },
      },
      beforeDeleteAccount: {
        on: {
          SHOW_PROVIDE_REASON: 'provideReason',
        },
      },
      provideReason: {
        on: {
          SHOW_SPECIAL_OFFER: 'specialOffer',
          SHOW_AUTOPILOT_PAUSE_OPTION: 'autopilotPauseOption',
          CANCEL_SUCCESS: 'cancelSuccess',
          SHOW_BEFORE_DELETE_ACCOUNT: 'beforeDeleteAccount',
          SHOW_DFY_OFFER: 'dfyOffer',
        },
      },
      dfyOffer: {
        on: {
          SHOW_SPECIAL_OFFER: 'specialOffer',
          SHOW_AUTOPILOT_PAUSE_OPTION: 'autopilotPauseOption',
          CANCEL_SUCCESS: 'cancelSuccess',
          SHOW_PROVIDE_REASON: 'provideReason',
        },
      },
      specialOffer: {
        on: {
          SHOW_PROVIDE_REASON: 'provideReason',
          SHOW_DFY_OFFER: 'dfyOffer',
          SHOW_AUTOPILOT_PAUSE_OPTION: 'autopilotPauseOption',
          CANCEL_SUCCESS: 'cancelSuccess',
          ACCEPT_OFFER: 'discountApplied',
        },
      },
      autopilotPauseOption: {
        on: {
          SHOW_SPECIAL_OFFER: 'specialOffer',
          SHOW_DFY_OFFER: 'dfyOffer',
          SHOW_PROVIDE_REASON: 'provideReason',
          CANCEL_SUCCESS: 'cancelSuccess',
          SHOW_DELETE_WORKSPACE_OPTION: 'deleteWorkspaceOption',
          SHOW_DELETE_ACCOUNT_OPTION: 'deleteAccountOption',
        },
      },
      deleteWorkspaceOption: {
        on: {
          SHOW_AUTOPILOT_PAUSE_OPTION: 'autopilotPauseOption',
        },
      },
      deleteAccountOption: {
        on: {
          SHOW_AUTOPILOT_PAUSE_OPTION: 'autopilotPauseOption',
        },
      },
      discountApplied: {},
      cancelSuccess: {
        on: {
          SHOW_AUTOPILOT_PAUSE_OPTION: 'autopilotPauseOption',
        },
      },
      payment: {
        on: {
          SELECT_PLAN: 'selectPlan',
          PAYMENT_SUCCEEDED: 'paymentSuccess',
        },
      },
      paymentSuccess: {
        on: {
          CONTINUE: 'success',
        },
      },
      success: {},
    },
  })
